import { FC } from 'react';
import { useHover } from '@/hooks/useHover';
import { Arrow } from '@/components/arrow';
import styles from './index.module.scss';
import { useScreenType } from '@web3/base-hooks';
import { openLink } from '@web3/base-utils';
import { scTrack } from '@web3/base-tracking';
import { Event, Page } from '@/config/track-config';

interface IProps {
  title?: string;
  onTitleClick?: () => void;
  jumpUrl?: string;
  appUrl?: string;
  children: React.ReactNode;
}

export const MarketPlaceItem: FC<IProps> = ({
  title,
  children,
  jumpUrl,
  appUrl,
}) => {
  const { active, bind } = useHover();
  const { isMobile } = useScreenType();

  const navTo = () => {
    scTrack(Event.Web3UserClick, {
      page_name: Page.Home,
      area: 'Marketplace',
      button_name: 'Inscriptions',
      params: (isMobile ? appUrl : jumpUrl) as string,
    });
    if (isMobile) {
      if (appUrl) {
        openLink(appUrl);
      }
      return;
    }
    window.open(jumpUrl, '_blank');
  };

  return (
    <div className={styles.marketplace_item}>
      <div
        className={styles.marketplace_item_head}
        {...bind}
        onClick={() => navTo()}
      >
        <div className={styles.marketplace_item_head__title}>{title}</div>
        <div target="_blank" rel="noreferrer">
          <Arrow active={active} />
        </div>
      </div>
      <div className={styles.marketplace_item_body}>{children}</div>
    </div>
  );
};
